const parseFloatNum = (value: number | string) => {
  return parseFloat(value as unknown as string)
}
export default function calcWeight(width: number, length: number, height: number, weight: number) {
  const wv = (parseFloatNum(height) * parseFloatNum(length) * parseFloatNum(width)) / 5000

  if (wv > weight) {
    const x = parseFloatNum(wv).toFixed(1)
    return parseFloatNum(x)
  } else {
    const y = parseFloatNum(weight).toFixed(1)
    return parseFloatNum(y)
  }
}
